import { Component } from '@angular/core';

import { PaginatedResponse } from '../../services/types';
import { SearchFilter, SearchLabel } from '../../types';
import { SELECT_FILTER } from '../../components/studies-table/studies-table-wrapper/studies-table-wrapper.component';
import { StudiesService } from '../../services/studies/studies.service';
import { StudiesTableStudy } from '../../components/studies-table/types';
import { STUDY_STATUS } from '../../constants/statuses';
import { STUDY_TABLE_COLUMN } from '../../components/studies-table/studies-table.component';
import { STUDY_TYPE } from '../../constants/study-types';

@Component({
  selector: 'app-cbr-studies',
  styleUrls: ['./cbr-studies.component.scss'],
  templateUrl: './cbr-studies.component.html',
})
export class CbrStudiesComponent {
  constructor(private studiesService: StudiesService) {
    this.getStudies = this.getStudies.bind(this);
  }

  tableColumns = [
    STUDY_TABLE_COLUMN.CREATED_AT,
    STUDY_TABLE_COLUMN.RUT,
    STUDY_TABLE_COLUMN.BUSINESS_NAME,
    STUDY_TABLE_COLUMN.CUSTOMER_NAME,
    STUDY_TABLE_COLUMN.STATUS_DISPLAY,
  ];
  textFilterLabels = [SearchLabel.BUSINESS_NAME, SearchLabel.RUT];
  defaultTextFilterLabel = SearchLabel.RUT;
  selectFilters = [
    { filter: SELECT_FILTER.STATUS, defaultValue: STUDY_STATUS.IN_STUDY },
  ];

  async getStudies(
    params: SearchFilter,
    pageUrl: string,
  ): Promise<PaginatedResponse<StudiesTableStudy[]>> {
    return await this.studiesService.getStudies(
      { ...params, type: STUDY_TYPE.CBR.toString() },
      pageUrl,
    );
  }
}
